<template>
  <div role="listitem" class="col-xs-12 col-sm-4">
    <div class="selected-seat flex-container">
      <div class="flex-item">
        <div class="text-green">
          <strong>{{ passenger.firstName }} {{ passenger.lastName }}</strong>
        </div>
        <div class="thin">{{ passenger.fare }}</div>
      </div>
      <div class="flex-item" v-if="isActive">
        <div class="thin">
          {{ $t('selectseat') }}
          <i class="fa fa-arrow-circle-down fa-lg text-muted"></i>
        </div>
      </div>
      <div class="flex-item" v-if="!isActive && dataSeat">
        <strong>{{ $t('seat') }}</strong>
        <div class="thin">{{ dataSeat.seatNumber }}</div>
      </div>
      <div class="flex-item" v-if="!isActive && dataSeat">
        <strong>{{ $t('row') }}</strong>
        <div class="thin">{{ dataSeat.rowLabel }}</div>
      </div>
      <div class="flex-item" v-if="!isActive && dataSeat">
        <strong>{{ $t('section') }}</strong>
        <div class="thin">{{ dataSeat.sectionName }}</div>
      </div>
      <div class="flex-item" v-if="!isActive">
        <div class="thin">
          <a href="#" @click.prevent="setActivePassenger">
            <span class="sr-only">{{ $t('editseat') }}</span>
            <i class="fa fa-pencil text-muted"></i>
          </a>
        </div>
      </div>
      <template v-if="dataSeat">
        <input type="hidden" class="js-passengerseat" :id="passengerNumber" :value="dataSeat.seatId" />
      </template>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  name: "seatMapPassenger",
  props: ["passenger", "index", "tripId"],
  components: {},
  data() {
    return {
      dataSeat: false
    };
  },
  mounted() {
    if (this.currentPassengerSeats.length) {
      let existingSelection = this.passenger.seats.filter(seat => {
        return seat.tripId == this.tripId;
      })[0];
      this.dataSeat = existingSelection ? existingSelection : false;
    }
    this.$root.$on("SEAT_SELECTION", seatSelection => {
      if (seatSelection.passenger == this.index) {
        //this.dataSeat = seatSelection;
        this.dataSeat = {
          seatMapId: seatSelection.seatMapId,
          sectionId: seatSelection.section._id,
          sectionName: seatSelection.section.label,
          rowLabel: seatSelection.row.label,
          seatNumber: seatSelection.seat.label,
          seatId: seatSelection.seat.id,
          scheduleId: seatSelection.scheduleId,
          tripId: seatSelection.tripId
        };
      }
    });
    this.$root.$on("SET_ACTIVE_PASSENGER", function () {
      this.$forceUpdate();
    });
  },
  computed: {
    passengerNumber() {
      return "Passenger" + this.index;
    },
    seatProp() {
      return this.passenger.seats.filter(seat => {
        return seat.tripId == this.tripId;
      })[0];
    },
    isActive() {
      return this.$store.state.seatMapActivePassenger == this.index;
    },
    selectedSeat() {
      let thistrip = this.tripId;
      let result = this.currentPassengerObject.seats.filter(function (seat) {
        return seat.tripId == thistrip;
      });
      return result[0];
    },
    currentPassengerObject() {
      return this.passengers[this.index];
    },
    currentPassengerSeats() {
      return this.passengers[this.index].seats;
    },
    ...mapGetters(["stateSelectedSeats"]),
    ...mapState(["passengerSeats", "passengers"])
  },
  methods: {
    setActivePassenger: function () {
      // When editing the seat release the current seat for the selected trip.
      this.$root.$emit("SET_ACTIVE_PASSENGER", {
        passenger: this.index,
        tripId: this.tripId
      });
      this.$store.commit("REMOVE_PASSENGER_SEAT", {
        passenger: this.index,
        tripId: this.tripId
      });
      this.dataSeat = false;

      this.$store.commit("setSeatMapActivePassenger", this.index);
    }
  }
};
</script>
<style lang="scss">
.selected-seat {
  padding: 10px;
  border: 3px solid $brand-primary;

  .flex-item {
    max-width: 100px;
    overflow: hidden;
  }
}
</style>